import React, { useState, useEffect } from 'react';

const GoogleTranslate = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('Select Language');

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Spanish' },
    { code: 'fr', name: 'French' },
    // Add more languages as needed
  ];

  const languageMap = {
    en: 'English',
    es: 'Spanish',
    fr: 'French',
    // Add more languages as needed
  };

  // Handle language selection from custom dropdown
  const handleLanguageSelect = (language) => {
    // Update the selected language in the custom dropdown
    setSelectedLanguage(language.name);
    setIsDropdownOpen(false);

    // Change the website language via Google Translate widget
    const selectElement = document.querySelector('.goog-te-combo');
    if (selectElement) {
      selectElement.value = language.code;
      selectElement.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  // Initialize the selected language based on Google Translate's current language
  useEffect(() => {
    const selectElement = document.querySelector('.goog-te-combo');
    if (selectElement) {
      const selectedCode = selectElement.value;
      setSelectedLanguage(languageMap[selectedCode] || 'Select Language');
    }
  }, []);

  return (
    <div className="language-dropdown Mobile-translater">
      <img
        src={'language-globe.png'}
        alt=""
        className="img-fluid language-globe"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      />
      <div className="custom-dropdown ml-2">
        <div className="selected-language notranslate" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
          {selectedLanguage}
          <img src={'dropdown.png'} alt="" className="img-fluid language-dropdown-icon" />
        </div>
        {isDropdownOpen && (
          <ul className="language-list notranslate">
            {languages.map((language) => (
              <li key={language.code} onClick={() => handleLanguageSelect(language)}>
                {language.name}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div id="google_translate_element_web" style={{ display: 'none' }}></div>
    </div>
  );
};

export default GoogleTranslate;
